import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import AdminService from "src/_services/AdminService";
import MerchantService from "src/_services/MerchantService";
import { apiCallStarted } from "../middleware/api";

export const searchMerchants = createAsyncThunk('merchants/searchMerchants', async searchParams => {
  const response = await MerchantService.searchMerchants();
  return response.data.body;
})

export const loadMerchants = createAsyncThunk(
  'loadMerchants/loadMerchants',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await AdminService.getMerchants(payload);
      return response.data.body;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);
const slice = createSlice({
  name: "merchants",
  initialState: {
    list: [],
    merchantDetails: {},
    loading: false,
    lastFetch: null,
    rowCount: 0,
    pageSize: 0,
    page: 0,
    waitingMerchantsCount: 0,
    error: null
  },
  reducers: {
    // merchantsRequested: (merchants, action) => {
    //   merchants.loading = true;
    // },
    // merchantsRequestSucceded: (merchants, action) => {
    //   const { merchants: { docs, totalDocs, limit, page } } = action.payload.body;
    //   if (page && page > merchants.page) {
    //     merchants.list = [...merchants.list, ...docs];
    //     merchants.page = page;
    //     merchants.rowCount = totalDocs;
    //     merchants.pageSize = limit;
    //   } else {
    //     // TODO: to be used in MerchantDetails Select List in Order, Driver, until converted to autoComplete
    //     merchants.list = docs;
    //     merchants.page = 1;
    //     merchants.rowCount = docs.length;
    //     merchants.pageSize = docs.length;
    //   }
    //   merchants.loading = false;
    //   merchants.lastFetch = Date.now();
    // },
    merchantsRequestFailed: (merchants, action) => {
      merchants.error = action?.payload?.message?? 'Something went wrong please try again';
    },
    merchantDetailsRequestSucceded: (merchants, action) => {
      merchants.error = null
      merchants.merchantDetails = action.payload.body;
    },
    merchantAdded: (merchants, action) => {
      merchants.list.push(action.payload);
    },
    merchantRemoved: (merchants, action) => {
      const index = merchants.list.findIndex(
        (merchant) => merchant.id === action.payload.id
      );
      merchants.list.splice(index, 1);
    },
    pageChanged: (merchants, action) => {
      const { page: targetPage } = action.payload;
      merchants.page = targetPage;
    },
    clearMerchants: (merchants, action) => {
      merchants.list = [];
      merchants.page = 0;
      merchants.rowCount = 0;
      merchants.pageSize = 0;
      merchants.lastFetch = null;
      merchants.loading = false;
    },
    clearMerchantDetails: (merchants, action) => {
      merchants.merchantDetails = {};
      merchants.error = null
    }
  },
  extraReducers: {
    [searchMerchants.fulfilled]: (state, action) => {
      state.list = action.payload;
    },
    //===========Get Merchants===================
    [loadMerchants.pending]: (state) => {
      state.loading = true;
    },
    [loadMerchants.fulfilled]: (state, { payload }) => {
      const { docs, totalDocs, limit, page } = payload;
      // if (page && page > state.page) {
      state.list = [...state.list, ...docs];
      state.page = page;
      state.rowCount = totalDocs;
      state.pageSize = limit;
      // } else {
      //   // TODO: to be used in MerchantDetails Select List in Order, Driver, until converted to autoComplete
      //   state.list = docs;
      //   state.page = 1;
      //   state.rowCount = docs.length;
      //   state.pageSize = docs.length;
      // }
      state.loading = false;
      state.lastFetch = Date.now();
    },
    [loadMerchants.rejected]: (state) => {
      state.loading = false;
    },
  }
});

export const {
  // merchantsRequested,
  // merchantsRequestSucceded,
  merchantsRequestFailed,
  merchantDetailsRequestSucceded,
  merchantAdded,
  merchantRemoved,
  pageChanged,
  clearMerchants,
  clearMerchantDetails
} = slice.actions;

// Action Creators
const url = "/v1/admin-panel/merchant";

// export const loadMerchants = (payload) => (dispatch, getState) => {
//   dispatch(
//     apiCallStarted({
//       url: `${url}?${Object.keys(payload)[0]}=${Object.values(payload)[0]}`,
//       onStart: merchantsRequested.type,
//       onSuccess: merchantsRequestSucceded.type,
//       onError: merchantsRequestFailed.type,
//     })
//   );
// };


export const loadMerchantDetails = (id) => (dispatch, getState) => {
  dispatch(
    apiCallStarted({
      url: `${url}/${id}`,
      // onStart: merchantsRequested.type,
      onSuccess: merchantDetailsRequestSucceded.type,
      onError: merchantsRequestFailed.type,
    })
  );
};

export default slice.reducer;
